document.addEventListener('DOMContentLoaded', function() {
  const readMore = document.querySelector('.read-more');
  const readLess = document.querySelector('.read-less');
  const shortDesc = document.querySelector('.description-short');
  const fullDesc = document.querySelector('.description-full');

  if(readMore && readLess && shortDesc && fullDesc) {
    readMore.addEventListener('click', function() {
      shortDesc.style.display = 'none';
      fullDesc.style.display = 'block';
    });

    readLess.addEventListener('click', function() {
      fullDesc.style.display = 'none';
      shortDesc.style.display = 'block';
    });
  }
});
